<div class="msa-dashboard">
    <app-dashboard [mainButtonClickEvent]="this.clickEvent.bind(this)"></app-dashboard>
</div>
